import { Skill } from "./Skill";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { SheetSectionEmptyText } from "@/components/SheetSectionEmptyText";
import { SheetSectionHeader } from "@/components/SheetSectionHeader";
import { SkillType } from "@/types";

export const SkillsSheetContent = ({ skills }: { skills: SkillType[] }) => {
  /* Render */
  const renderContent = () => {
    if (!skills.length) {
      return (
        <SheetSectionEmptyText text="This candidate hasn't added any skills yet." />
      );
    }

    return (
      <Row className="flex-wrap gap-2">
        {skills.map((skill) => (
          <Skill key={skill.id} skill={skill} />
        ))}
      </Row>
    );
  };

  const render = () => {
    return (
      <Column className="gap-6 border-t border-slate-200 py-6">
        <Row className="items-center justify-between">
          <SheetSectionHeader title="Skills" />
        </Row>
        {renderContent()}
      </Column>
    );
  };

  return render();
};
